export default __webpack_public_path__ + "static/media/BT_Icons_WiFi.d8587a52.svg";